import { BankImportId } from '../bank-import/BankImportId'
import { Codebook } from '../Codebook'
import { FileType } from '../file-type/FileType'

export class BankImport extends Codebook<BankImportId> {
  static readonly FIO_CZ = new BankImport(BankImportId.FIO_CZ, 'FIOBCZPP', FileType.GPC)
  static readonly FIO_SK = new BankImport(BankImportId.FIO_SK, 'FIOZSKBA', FileType.GPC)
  static readonly KB = new BankImport(BankImportId.KB, 'KOMBCZPP', FileType.GPC)
  static readonly CS = new BankImport(BankImportId.CS, 'GIBACZPX', FileType.JSON)
  static readonly CSOB = new BankImport(BankImportId.CSOB, 'CEKOCZPP', FileType.GPC)
  static readonly SLOVAK_SAVINGS_BANK = new BankImport(
    BankImportId.SLOVAK_SAVINGS_BANK,
    'GIBASKBX',
    FileType.XML,
  )
  static readonly TATRABANK = new BankImport(BankImportId.TATRABANK, 'TATRSKBX', FileType.XML)
  static readonly UNICREDIT_CZ = new BankImport(BankImportId.UNICREDIT_CZ, 'BACXCZPP', FileType.GPC)
  static readonly ING_PL = new BankImport(BankImportId.ING_PL, 'INGBPLPW', FileType.GPC)

  private constructor(
    public readonly id: BankImportId,
    public readonly swift: string,
    public readonly supportedFileType: FileType,
  ) {
    super(id)
  }

  static getByBankCode = (bankCode: BankImportId): null | BankImport => {
    const value = BankImport.all().find((item: BankImport) => item.id === bankCode)

    if (value === undefined) {
      return null
    }

    return value
  }

  static getBySwift = (swift: string): null | BankImport => {
    const value = BankImport.all().find((item: BankImport) => item.swift === swift)

    if (value === undefined) {
      return null
    }

    return value
  }
}
